import { AbstractTypeEntityFacade } from '../abstractions/AbstractTypeEntityFacade';
import { ContactTypesService } from '@control-tower/platform-core';
import { Injectable, inject } from '@angular/core';
import { LoggerService } from '@pf/shared-services';
import { TypeEntityStore } from '../stores/TypeEntityStore';
import { TypeEntityTypes } from '@pf/shared-common';

@Injectable()
export class ContactTypeFacade extends AbstractTypeEntityFacade<ContactTypesService> {
    constructor() {
        const typeService = inject(ContactTypesService);
        const store = inject(TypeEntityStore);
        const logger = inject(LoggerService);

        super(
            store,
            logger,
            typeService,
            'contactTypeGetAll',
            TypeEntityTypes.ContactType
        );
    }
}
